import { useMenuStore } from "@shared/stores/menu";
import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export function clearBreadCrumbs(
  to?: RouteLocationNormalized,
  from?: RouteLocationNormalized,
  next?: NavigationGuardNext
) {
  // Only clear breadcrumbs if we're navigating to a different route
  // Don't clear if only query parameters changed (e.g., tab switching)
  if (to && from && to.name === from.name) {
    if (next) next();
    return;
  }
  
  const menuStore = useMenuStore();
  menuStore.unsetBreadCrumbs();
  
  if (next) next();
}
